import { render, staticRenderFns } from "./ExamAttributeGroupDetailsAction.vue?vue&type=template&id=18f43120&scoped=true&"
import script from "./ExamAttributeGroupDetailsAction.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeGroupDetailsAction.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeGroupDetailsAction.vue?vue&type=style&index=0&id=18f43120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f43120",
  null
  
)

export default component.exports